import * as React from 'react';
import { Spin, Card, Button, Breadcrumb, Row, Col, Modal, Icon, Dropdown, Menu, message } from 'antd';
import TestList from './test/TestList';
import TestFilter from './test/TestFilter';
import { IcommonProps } from './common/props';
import service from '../service/apolloclient.service';
import Constants from './common/constants';
import '../css/Tests.scss';
import Comparator from './common/comparer';
import Util from './common/utils';
import Print from './common/print';
import Export from './common/export';
import ShareTests from './test/ShareTest';
import { STATICKEYS, staticProperties } from './common/staticProperties';
import { MSGDISPLAYTIME } from './common/constants';
import { VIEWSTATE } from './common/constants';
import Auth from './common/auth';
import { Tasks } from './common/auth';
import { BASELINETYPE } from './common/constants';
import Token from './common/token';
import strings from '../eyeguide-localization/test/string.test';
import LocalStorage from '../service/localstorage';
import TestPdf from './test/testPdf';
import TestDonwloadHelper from './common/testDownloadHelper';
const testDownloader = new TestDonwloadHelper();
import * as jsPDF from 'jspdf';

const storage = new LocalStorage();

interface ItestProps extends IcommonProps {
    match: any;
    location: any;
}

interface ItestState {
    origTests: any;
    tests: any;
    error: boolean;
    sharetests: Array<any>;
    modalVisible: boolean;
    filterObj: any;
    prevFilterObj: any;
    organizations: any;
    exportModalVisisble: boolean;
    shareModalVisible: boolean;
    shareUsers: any;
    rosterName: string;
    emptyText: string;
    loading: boolean;
    showHealthData: boolean;
    isFocusUser: boolean;
    testExporting: boolean;
    testExportingTip: string;
}

export default class Tests extends React.Component<ItestProps, ItestState> {
    iframe: HTMLIFrameElement | null;
    menu = (
        <Menu 
                onClick={(event) => {
                            switch (event.key) {
                                case '2': this.exportFile(); break;
                                case '1': this.exportTestRecord(); break;
                                default: break;
                            }
                        }}
        >
          <Menu.Item key="1">Test</Menu.Item>
          <Menu.Item key="2">CSV</Menu.Item>
        </Menu>
    );

    constructor(props: ItestProps) {
        super(props);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.state = {
          origTests: [],
          error : false,
          tests: [],
          sharetests: [],
          modalVisible: false,
          filterObj: [],
          prevFilterObj: [],
          organizations: [],
          exportModalVisisble: false ,
          shareModalVisible: false,
          shareUsers: [],
          rosterName: '',
          emptyText: '',
          loading: true,
          showHealthData: Auth.canPerformTask(roleid, Tasks.canViewHealthData),
          isFocusUser: Auth.canPerformTask(roleid, Tasks.isFocusUser),
          testExporting: false,
          testExportingTip: ''
        };
        this.setShareTests = this.setShareTests.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        this.setShareModalVisible = this.setShareModalVisible.bind(this);
        this.shareTestClick = this.shareTestClick.bind(this);
        this.shareTests = this.shareTests.bind(this);
        }

    componentDidMount() {
        staticProperties.set(STATICKEYS.selectedRoster, this.props.match.params.rosterid);
        staticProperties.set(STATICKEYS.selectedKey, this.props.match.params.rosterid 
                    + VIEWSTATE.TEST);

        this.intializeTestList(this.props.match.params.rosterid);
        console.log('tests componentDidMount');
        // this.getOrganizations();
        this.getRoster(this.props.match.params.rosterid);
    }

    componentWillReceiveProps(nextProps: any) {
        staticProperties.set(STATICKEYS.selectedRoster, nextProps.match.params.rosterid);
        staticProperties.set(STATICKEYS.selectedKey, nextProps.match.params.rosterid 
                    + VIEWSTATE.TEST);

        if ( (this.props.match.params.rosterid !== nextProps.match.params.rosterid) )  {
            this.intializeTestList(nextProps.match.params.rosterid);
            this.getRoster(nextProps.match.params.rosterid);
        }
    }

    setShareTests(testlist: Array<any>) {
        console.log('share list', testlist);
        this.setState({

            sharetests: testlist
        });
    }

    render() {
        if (this.state.isFocusUser && storage.getSelectedOrg() === '') {
            history.forward();
            return <div/>;
        } else {
        return (
            <div className="Tests">
                <Spin spinning={this.state.testExporting} tip={this.state.testExportingTip}>
                <Card >
                    <Breadcrumb>
                        <Breadcrumb.Item ><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item >{this.state.rosterName + ' ' + strings.lsTestsTxt}</Breadcrumb.Item>
                    </Breadcrumb>
                        <br/>
                    <h3> {strings.lsViewTestsTxt} </h3>
                </Card>
                <div className="contentWithoutTitle">
                        <Card className="filterCard">
                            <span 
                                className="filterIcon"
                                onClick={e => {
                                    console.log('clicked');
                                    this.setState({
                                        modalVisible: true
                                    });
                                 }}
                            >
                            <Icon 
                                type="filter" 
                                style={{fontSize: 19, float: 'right'}}
                            />
                            </span>
                            <span style={{'fontSize': '14px', 'fontWeight': 'normal'}}>
                               <span hidden={this.checkIfFilterExists('', true)}>
                                    {strings.lsNoFilterTxt}
                                </span>
                                <div className="filterContent" hidden={!this.checkIfFilterExists('', true)}>
                                    <Button 
                                        className="clearFilter" 
                                        onClick={e => {
                                            this.clearFilters();
                                        }}
                                    >
                                        {strings.lsClearFiltersTxt}
                                    </Button>
                                    <Row className="filterRow" hidden={this.checkIfFilterExists('name')}>
                                        <Col span={5}>{strings.lsNameTxt}:</Col> 
                                        <Col span={15}> {this.getFilterValues('name')} </Col>
                                    </Row>
                                    <Row className="filterRow" hidden={this.checkIfFilterExists('testType')}>
                                        <Col span={5}>{strings.lsScoreTypeTxt}:</Col>
                                        <Col span={15}>{this.getFilterValues('testType')} </Col>
                                    </Row>
                                    <Row className="filterRow" hidden={this.checkIfFilterExists('startDate')}>
                                        <Col span={5}>{strings.lsStartDateTxt}:</Col>
                                        <Col span={15}>{this.getFilterValues('startDate')}</Col>
                                    </Row>
                                    <Row className="filterRow" hidden={this.checkIfFilterExists('endDate')}>
                                        <Col span={5}>{strings.lsEndDateTxt}:</Col>
                                        <Col span={15}>{this.getFilterValues('endDate')}</Col>
                                    </Row>
                                    <Row className="filterRow" hidden={this.checkIfFilterExists('organization')}>
                                        <Col span={5}>{strings.lsOrgsTxt}:</Col>
                                        <Col span={15}>{this.getFilterValues('organization')}</Col>
                                    </Row>
                                    <Row className="filterRow" hidden={this.checkIfFilterExists('baseline')}>
                                        <Col span={5}>{strings.lsBaselineTxt}:</Col>
                                        <Col span={15}>{this.getFilterValues('baseline')}</Col>
                                    </Row>
                                    {/* <Row className="filterRow" hidden={this.checkIfFilterExists('concussed')}>
                                        <Col span={5}>{strings.lsConcussionTxt}:</Col>
                                        <Col span={15}>{this.getFilterValues('concussed')}</Col>
                                    </Row> */}
                                </div>
                            </span>

                        </Card>    
                <Card 
                    title={strings.lsViewTestsTxt}
                    bordered={false}
                    className="card"
                >
                    <Button 
                        icon="right" 
                        type="primary" 
                        style={{marginBottom: 20 }} 
                        disabled={this.state.sharetests.length === 0}
                        onClick={() => this.shareTestClick()}
                    > {strings.lsShareTestTxt}
                    </Button>
                    <Button
                        disabled={this.state.sharetests.length === 0} 
                        style={{marginLeft: 10, marginBottom: 20 }}
                        onClick={() => this.printList()}
                    >{strings.lsPrintTxt}
                    </Button> 
                    <Dropdown 
                        trigger={['click']}
                        overlay={this.menu}
                        getPopupContainer={this.getContainer}
                        disabled={this.state.sharetests.length === 0}
                    >
                        <Button 
                            className="downloadBtn"
                            disabled={this.state.sharetests.length === 0}
                        > 
                            {strings.lsDwnldTxt} <Icon type="down" style={{ fontSize: 15}}/> 
                        </Button>
                    </Dropdown>
                    <Modal
                        title={strings.lsDownloadTextTxt}
                        visible={this.state.exportModalVisisble}
                        onOk={() => this.setState({exportModalVisisble: false})}
                        okText={strings.lsOkTxt}
                        width={350}
                        bodyStyle={{padding: 0 }}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button 
                                    key="Ok" 
                                    type="primary"  
                                    onClick={() => this.setState({exportModalVisisble: false})}
                            >
                            {strings.lsOkTxt}
                            </Button>,
                        ]}
                    >
                        <Row style={{padding: '19px'}}>
                            {strings.lsDwbldSuccessTxt}
                        </Row>
                    </Modal>                     
                    <iframe 
                        style={{height: 0, width: 0, border: 'none'}} 
                        ref={el => this.iframe = el} 
                    />                
                    <TestList 
                        organizationID={this.props.organizationID} 
                        rosterID={this.props.rosterID} 
                        tests={this.state.tests}
                        notifySelectedTests={this.setShareTests}
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        pagination={true}
                        sorting={true}
                        showAthelete={true}
                        showDownloadAction={false}
                        loading={this.state.loading}
                        emptyText={this.state.emptyText}
                        showEditAction={false}
                        notifyTestUpdated={undefined}
                    />
                </Card>
                </div>
                    <Modal 
                        className="modal"
                        title={strings.lsTestFilterHdrTxt}
                        visible={this.state.modalVisible}
                        okText={strings.lsFilterTxt}
                        onOk={() => this.setModalVisible(1)}
                        onCancel={() => this.setModalVisible(0)}
                        width={1000}
                        bodyStyle={{padding: 0 }}
                        maskClosable={false}
                        closable={false}
                    >
                    <TestFilter
                        notifyChangeFilter={this.changeFilter}
                        form={''}
                        showOrg={false}
                        showNotifs={false}
                        isOpen={this.state.modalVisible}
                        // organization={this.state.organizations}
                        filterObj={this.state.filterObj}
                    />
                         
                    </Modal>
                    <Modal
                        className="modal"
                        title={strings.lsShareTestTxt}
                        visible={this.state.shareModalVisible}
                        okText={strings.lsShareTxt}
                        onOk={() => this.setShareModalVisible(1)}
                        onCancel={() => this.setShareModalVisible(0)}
                        width={800}
                        maskClosable={false}
                        closable={false}
                    >
                        <ShareTests
                            sharedTests={this.state.sharetests}
                            notifyUsers={this.shareTests}
                            isOpen={this.state.shareModalVisible}
                        />
                    </Modal>
                </Spin>
            </div>
        );
    }
    }

    private async intializeTestList(rosterID: string) {
        console.log('getTestscalled');
        let ser = new service();
        let tests: any = await ser.getTests(rosterID);
        console.log('tests', tests);
        this.setState({
            tests : tests,
            origTests: tests,
            filterObj: [],
            prevFilterObj: [],
            emptyText: tests.length === 0 ? 'No data' : '',
            loading: false
        });
    }

    /**
     * This function is called when filter changes in TestFilter component
     * @param filterObj Changes filter object
     */
    private changeFilter(filterObj: any) {
        console.log('changeFilter', filterObj);
        this.setState({ filterObj: filterObj });
    }

    /**
     * This function is called when Ok/Cancel is clicked on filter modal
     * Filters the list if Ok. Closes the modal
     * @param event 1 for Ok . 0 for cancel
     */
    private setModalVisible(event: number) {
        if (event === 1) {// filter click
             this.filterList();
        } else {
            this.setState({filterObj: {...this.state.prevFilterObj}});
        }
        this.setState({
            modalVisible: false,
        });

    }

    /**
     * Filters the list 
     */
    private filterList() {
        console.log('filterObj', this.state.filterObj);
        console.log('testlist', this.state.origTests);
        let filterObject = this.state.filterObj;
        staticProperties.set(STATICKEYS.clearSelection, true);
        let filteredTests = this.state.origTests.filter(function(obj: any[]) {
            let matched = false;   
            let comp: Comparator;
            comp = new Comparator();
            matched = comp.compare(filterObject, obj);
            // console.log('comparator', matched);
            if (matched) {
                return true;
            } else {
                return false;
            }
        });
        // console.log('filteredTests', filteredTests);
        this.setState({tests: filteredTests, prevFilterObj: {...this.state.filterObj}});
    }

    /**
     * Fetches organization list
     */
    // private async getOrganizations() {
    //     let ser = new service();
    //     let orgs = await ser.getOrganizations();
    //     this.setState({organizations: orgs});
    // }

    /**
     * Reurns filter object value to display on UI.
     * @param key Filter Property 
     */
    private getFilterValues(key: string): string {
        if (this.state.prevFilterObj[key] instanceof Array) {
            console.log('gender', this.state.prevFilterObj[key]);
            let values = this.state.prevFilterObj[key];
            if (key === 'gender') {
                console.log('gennderCons', Constants.getGender());
                let valString: any = ''; 
                let valCons = Constants.getGender();
                for (let j = 0; j < values.length; j ++) {
                    j === values.length - 1 ? valString += valCons[values[j]] : valString += valCons[values[j]] + ', ';
                }
                return valString;
            } else {
                let valString: any = '';
                for (let j = 0; j < values.length; j ++) {
                    j === values.length - 1 ? valString += values[j] : valString += values[j] + ', ';
                }
                return valString; 
            }
        } else if (this.isEmpty(this.state.prevFilterObj[key])) {
            return '';
        } else {
            if (key === 'concussed' || key === 'baseline') {
                console.log('consussed value', Constants.getConcussionFilterValue[this.state.prevFilterObj[key]]);
                return Constants.getConcussionFilterValue()[this.state.prevFilterObj[key]];
            } else if (key === 'notifyEmail' || key === 'notifyPhone') {
                return Constants.getNotifyFilterType()[this.state.prevFilterObj[key]];
            }
            return this.state.prevFilterObj[key];
        }
    }

    /**
     * Checks if an object is empty
     * @param obj Object to check if empty
     */
    private isEmpty(obj: any): boolean {
        if (obj instanceof Object) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        } else {
            return false;
        }
    }

    /**
     * Checks if filter is applied to the property
     * If applied displays on UI 
     * @param property 
     * @param chkIfFiltered 
     */
    private checkIfFilterExists(property: string, chkIfFiltered: boolean = false): boolean {
        
        if (chkIfFiltered) {
            return Util.isObjectEmpty(this.state.filterObj) === true ? false : true;
        } else if (Util.isObjectEmpty(this.state.filterObj) === false) {
            let value = this.getFilterValues(property);
            if (value === '' || value === undefined) { return true; } else { return false; }
        } else {
            return true;
        }
    }

    /**
     * Clears the filter applied
     */
    private clearFilters() {
        this.intializeTestList(this.props.match.params.rosterid);
        this.setState({
            filterObj: [],
            prevFilterObj: []
        });
    }

    /**
     * Handles test list print
     */
    private printList() {
        console.log('profilesFromPrint', this.state.tests);
        let buildData: any;
        buildData = this.buildTestData(this.state.tests, this.state.sharetests);
        if (buildData.length > 0) {
            Print.printContents(buildData, strings.lsTestsTxt, this.iframe);
        }
    }

    /**
     * export the current test records
     */
    private exportTestRecord() {
        let canvas = [];
        let doc = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'letter',
        });
        let ser = new service();
        this.setState({testExporting: true, testExportingTip: 'Exporting 0 of ' + this.state.sharetests.length });
        this.state.sharetests.reduce(
            (prev, testid, i) => {
                return prev.then(async () => {
                    this.setState({
                                    testExporting: true, 
                                    testExportingTip: 'Exporting ' + i + ' of '  + this.state.sharetests.length });
                    let testResult = await ser.getTestResults(testid, 0);
                    let testHistory = await ser.getTestsAfterLastBaseline(
                        testResult[0].playerid, testResult[0].testtimestamp
                    );
                    return TestPdf({
                        index: i,
                        state: {testResult: testResult[0], testHistory},
                        doc: doc,
                        isLast: i === this.state.sharetests.length - 1,
                        setCanvas: () => testDownloader.downloadTest(testResult[0], i, canvas, ser),
                        notifyDownload: () => this.setState({
                                                            exportModalVisisble: true, 
                                                            testExporting: false, 
                                                            testExportingTip: ''})
                    });
                });
            },
            Promise.resolve()
        );
    }

    /**
     * Handles test list export
     */
    private exportFile() {
        console.log('profilesFromPrint', this.state.tests);
        let buildData: any;
        buildData = this.buildTestData(this.state.tests, this.state.sharetests);
        if (buildData.length > 0) {
            Export.exportCSVFile(buildData, 'tests');
            this.setState({exportModalVisisble: true});
        }
    }
    
    /**
     * Attatches dropdown lists to parent containers to avoid displacement during scroll
     */
    private getContainer = (triggernode) => {
        // debugger;
        return triggernode.parentNode;
    }

    /**
     * Build test data from test list for Export/Print
     * @param tests Test List
     */
    private buildTestData(tests: Array<any>, selectedTest: Array<any> | undefined = undefined) {
        let columnData: Array<any> = [];
        tests.forEach( (element: any) => {
            if ( selectedTest !== undefined && 
                    selectedTest.findIndex( testid => testid === element.testid ) === -1 ) {
                return;
            }
            let data: any = {};
            let genderValue = Util.getProfileValue(element.athlete.playerinfo, 'gender');
            let birthdateValue = Util.getProfileValue(element.athlete.playerinfo, 'birthdate');
            if (this.state.showHealthData) {
                data = {
                name: element.athlete.firstname + ' ' + element.athlete.lastname,
                date_and_time: Util.getDate(element.testtimestamp) + ' ' + Util.getTime(element.testtimestamp),
                test_type: element.testtag,
                score_type: element.baseline === 1 ? strings.lsBaselineTxt : 
                            Util.getLocalizedTestType(element.range) ,
                    // dr_dx_concussion: Util.getConcussed(element.concussed),
                score: Util.formatNumber(element.score, 2),                
                id: Util.getProfileValue(element.athlete.playerinfo, 'profileID'),
                gender: genderValue !== '' ? Constants.getGender()[genderValue] : genderValue,
                birthdate: birthdateValue !== '' ? Util.getDateFromTimestamp(birthdateValue) : birthdateValue,
                level: Util.getProfileValue(element.athlete.playerinfo, 'level'),
                sport: Util.getProfileValue(element.athlete.playerinfo, 'sport'),
                organization: element.athlete.organizationname           
            };
            }  else {
                data = {
                    name: element.athlete.firstname + ' ' + element.athlete.lastname,
                    date_and_time: Util.getDate(element.testtimestamp) + ' ' + Util.getTime(element.testtimestamp),
                    test_type: element.testtag,
                    score_type: element.baseline === 1 ? BASELINETYPE.BASELINE : BASELINETYPE.TEST,
                    id: Util.getProfileValue(element.athlete.playerinfo, 'profileID'),
                    gender: genderValue !== '' ? Constants.getGender()[genderValue] : genderValue,
                    birthdate: birthdateValue !== '' ? Util.getDateFromTimestamp(birthdateValue) : birthdateValue,
                    level: Util.getProfileValue(element.athlete.playerinfo, 'level'),
                    sport: Util.getProfileValue(element.athlete.playerinfo, 'sport'), 
                    organization: element.athlete.organizationname   
                };
            }
            columnData.push(data);
        }); 
        return columnData;
    }

    /**
     * This function is called when Ok/Cancel button is clicked on Share Modal.
     * Handles sharing as per the event
     * @param event 1 for Ok and 0 for cancel
     */
    private async setShareModalVisible(event: number) {
        if (event === 1) { // share
            let testids = this.state.sharetests;
            let input: any = [];
            console.log('modalVisible share users', this.state.shareUsers);
            if (this.state.shareUsers.length > 0) {
                this.state.shareUsers.forEach((element: any) => {
                    input.push({firstname: element.fname, lastname: element.lname,
                        email: element.email, phone: element.phone});
                });
                console.log('input to create', input);
                console.log('testids to create', testids);
                staticProperties.set(STATICKEYS.clearSelection, true);
                this.setState({ sharetests: [], shareUsers: [] });
                let ser = new service();
                let response = await ser.createSharedTest(testids, 0, input);
                console.log('create response', response);
                if (response.status === 0) {
                    message.success(strings.lsTestShareSuccess, MSGDISPLAYTIME);
                } else {
                    message.error(strings.lsTestShareFailedTxt, MSGDISPLAYTIME);
                }
            } else {
                return;
            }
        }
        this.setState({
            shareModalVisible: false
        });
        console.log('number');
    }

    /**
     * This function is called when Share button is clicked
     * Share modal is displayed on click
     */
    private shareTestClick() {
        this.setState({
            shareModalVisible: true
        });
    }

    /**
     * This function is called when Add/Delete is clicked in ShareTest Component
     * @param shareUsers Users with which tets is to be shared
     */
    private shareTests(shareUsers: any) {
        this.setState({
            shareUsers
        });
        console.log('shareTests', shareUsers);
    }

    /**
     * Fetches the roster name from API to display in BreadCrumb
     * @param rosterid 
     */
    private async getRoster(rosterid: string) {
        if (rosterid !== '' && rosterid !== null && rosterid !== undefined) {
            let ser = new service();
            let roster = await ser.getOrganizationByRoster(rosterid);
            this.setState({rosterName: roster.name});
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/Tests.tsx